export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex w-12 h-12 rounded-2xl bg-accent-100 items-center justify-center mb-4">
              <i className="ri-heart-line text-accent-600 text-2xl"></i>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">关于爱漫画</h2>
          </div>

          <div className="bg-background-50 border border-background-200 rounded-2xl p-8 md:p-10">
            <div className="prose prose-sm max-w-none text-foreground-600 leading-relaxed space-y-5">
              <p className="text-base md:text-lg font-medium text-foreground-800">
                爱漫画网诞生于对漫画阅读体验的执着追求。我们深知，每一个漫画爱好者都渴望在<span className="text-primary-600 font-semibold">无广告干扰</span>的环境里，用自己最喜欢的方式沉浸到故事中去。
              </p>
              <p className="text-sm md:text-base">
                为此，我们精心打磨了<strong>下拉式漫画阅读</strong>、<strong>经典翻页漫画</strong>、<strong>无弹窗漫画</strong>以及<strong>漫画全屏观看</strong>四种核心阅读模式。无论你是习惯指尖轻滑的移动端用户，还是偏爱大屏沉浸的桌面端读者，都能在这里找到最契合你阅读节奏的方式。
              </p>
              <p className="text-sm md:text-base">
                平台目前已收录超过 <span className="text-accent-600 font-bold">10,000 部</span>漫画资源，涵盖热血少年、恋爱少女、悬疑推理、奇幻冒险等全品类题材。我们坚持<strong>每日同步更新</strong>热门连载，确保读者能在第一时间追上心仪作品的最新话。
              </p>
              <p className="text-sm md:text-base">
                爱漫画网不只是一个在线阅读平台，更是一个属于漫画爱好者的精神角落。我们相信，好的阅读体验能让故事更有温度——这就是我们存在的意义。
              </p>
            </div>

            <div className="grid grid-cols-3 gap-4 mt-10 pt-8 border-t border-background-200">
              {[
                { num: '10,000+', label: '漫画资源' },
                { num: '每日更新', label: '连载同步' },
                { num: '4 种', label: '阅读模式' },
              ].map((s) => (
                <div key={s.label} className="text-center">
                  <div className="font-heading text-xl md:text-2xl font-bold text-accent-600">{s.num}</div>
                  <div className="text-xs md:text-sm text-foreground-500 mt-1">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}